'use client';

import {Center} from '@linx-security/ui';
import type {ReactNode} from 'react';

const LoginLayout = ({children}: {children: ReactNode}) => {
  return (
    <Center height={`100vh`}>
      <div className="flex flex-col items-center w-full sm:w-96">
        <div className="py-0 sm:py-8 px-4 sm:px-10 w-full flex justify-center">{children}</div>
      </div>
    </Center>
  );
};

export default LoginLayout;
